import React from 'react';
import { useNavigate } from 'react-router';
import './GreetingSection.css';

interface GreetingSectionProps {
    userName: string;
    subtitle?: string;
}

export const GreetingSection: React.FC<GreetingSectionProps> = ({
    userName,
    subtitle = "오늘도 즐거운 하루 되세요!"
}) => {
    const navigate = useNavigate();

    return (
        <div className="home-greeting-section">
            <div className="home-greeting-subtitle">{subtitle}</div>
            <div className="home-greeting-title-wrapper">
                <div
                    className="home-greeting-profile-image"
                    onClick={() => navigate('/settings/profile')}
                />
                <div className="home-greeting-title">안녕하세요, {userName}님 👋</div>
            </div>
        </div>
    );
};
